import { render, staticRenderFns } from "./ServiceProviderProducts.vue?vue&type=template&id=2fc07988&"
import script from "./ServiceProviderProducts.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports